import {
  EastRounded,
  /* EditOutlined, */ TaskAltRounded
} from '@mui/icons-material';
import { Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { styled as MuiStyled, useTheme } from '@mui/material/styles';
import AryModal from 'framework/base/components/AryModal';
import { TRANSFER_BETWEEN_ACCOUNTS_REPORT_PATH } from 'framework/base/constants/aryReportPaths';
import { createNewReportTab } from 'framework/base/utils/Utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// *************************** styled components *************************

const CustomLibraryAddCheckOutlined = MuiStyled(TaskAltRounded)`
    width: 75px;
    height: 75px;
    padding: 20px;
    background-color: ${(props) => props.theme.chip.green.background};
    color: ${(props) => props.theme.chip.green.text};
    border-radius: 50%;
`;

// *************************** end styled components *************************

const ReceiptModal = ({
  open,
  handleClose,
  debtorAccountNumber,
  creditorAccountNumber,
  onReceiptModalClose,
  hideRepeatOperation,
  handleChangeAccountNumber,
  handleRepeatOperation,
  transactionId
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // const hasAddOrEditTransferBetweenAccountsAccess =
  //   auth.TransferBetweenAccountsRE;

  return (
    <AryModal
      open={open}
      handleClose={() => {
        if (onReceiptModalClose) {
          onReceiptModalClose();
        }
        handleClose();
      }}
      noCloseOnOutsideClicked
      width="350px"
      descriptionSpacingToTitle="-32px"
      justifyContent="center"
      rowSpacing="8px"
    >
      <Grid item xs={12} mb="24px">
        <Stack direction="column" spacing="8px" sx={{ textAlign: 'center' }}>
          <div>
            <CustomLibraryAddCheckOutlined />
          </div>
          <Typography variant="h4Heavy" sx={{ color: theme.text.green.color }}>
            {t('RegisterTransactionMsg')}.
          </Typography>
          <Typography
            fontSize="12px"
            fontWeight="700"
            lineHeight="24px"
            color={theme.text.secondary.color}
          >
            {t('ShareReceiptText')}
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            createNewReportTab(TRANSFER_BETWEEN_ACCOUNTS_REPORT_PATH, [
              { key: 'id', value: transactionId },
              { key: 'has-header', value: true }
            ]);
          }}
        >
          {t('PrintReceiptWithHeader')}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => {
            createNewReportTab(TRANSFER_BETWEEN_ACCOUNTS_REPORT_PATH, [
              { key: 'id', value: transactionId },
              { key: 'has-header', value: false }
            ]);
          }}
        >
          {t('PrintReceiptWithoutHeader')}
        </Button>
      </Grid>
      <Grid item xs={12} m="8px 0">
        <Divider orientation="horizontal" />
      </Grid>
      {/* {hasAddOrEditTransferBetweenAccountsAccess && (
        <Grid item xs={12}>
          <Button
            variant="outlined"
            color="green"
            fullWidth
            startIcon={<EditOutlined />}
          >
            {t('receiptModal.editTransaction')}
          </Button>
        </Grid>
      )} */}

      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<EastRounded />}
          onClick={() => {
            if (!creditorAccountNumber) {
              if (onReceiptModalClose) {
                onReceiptModalClose();
              }
              handleClose();
            } else if (handleChangeAccountNumber) {
              handleChangeAccountNumber(creditorAccountNumber);
              handleClose();
            } else {
              navigate('../global-ledger/customer/account-information', {
                state: {
                  accountNumber: creditorAccountNumber
                }
              });
              handleClose();
            }
          }}
        >
          {t('VisitCreditorAccount')}
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<EastRounded />}
          onClick={() => {
            if (!debtorAccountNumber) {
              if (onReceiptModalClose) {
                onReceiptModalClose();
              }
              handleClose();
            } else if (handleChangeAccountNumber) {
              handleChangeAccountNumber(debtorAccountNumber);
              handleClose();
            } else {
              navigate('../global-ledger/customer/account-information', {
                state: {
                  accountNumber: debtorAccountNumber
                }
              });
              handleClose();
            }
          }}
        >
          {t('VisitDebtorAccount')}
        </Button>
      </Grid>

      {!hideRepeatOperation && (
        <Grid item xs={12}>
          <Button
            variant="text"
            fullWidth
            onClick={() => {
              if (onReceiptModalClose) {
                onReceiptModalClose();
              }
              handleRepeatOperation();
            }}
          >
            {t('RepeatOperation')}
          </Button>
        </Grid>
      )}
    </AryModal>
  );
};

export default ReceiptModal;
